export enum APIEndpoints {
  private = "private",
  public = "public",
}

export enum QueryKeysEnum {
  userProfiles = "userProfiles",
  data = "data",
  dataSchema = "dataSchema",
  dataIndividual = "dataIndividual",
  dataIndividualFile = "dataIndividualFile",
  organizations = "organizations",
  schemas = "schemas",
  schemaVersions = "schemaVersions",
  variantmap = "variantmap",
  registries = "registries",
  cohorts = "cohorts",
  registryData = "registryData",
  cohortData = "cohortData",
  registrySchema = "registrySchema",
  stats = "stats",
}

export class QueryKeys {
  static userProfiles(): string[] {
    return [QueryKeysEnum.userProfiles]
  }
  static cohorts(): string[] {
    return [QueryKeysEnum.cohorts]
  }
  static cohortsDetail(cohortId: string = ""): string[] {
    return [QueryKeysEnum.cohorts, cohortId]
  }
  static cohortData(): string[] {
    return [QueryKeysEnum.cohortData]
  }
  static cohortDataDetail(cohortId: string = ""): string[] {
    return [QueryKeysEnum.cohortData, cohortId]
  }
  static registries(): string[] {
    return [QueryKeysEnum.registries]
  }
  static registriesDetail(registryId: string = ""): string[] {
    return [QueryKeysEnum.registries, registryId]
  }
  static registryData(): string[] {
    return [QueryKeysEnum.registryData]
  }
  static registryDataDetail(registryId: string = ""): string[] {
    return [QueryKeysEnum.registryData, registryId]
  }
  static registryIndividualData(registryId: string, individualId: string): string[] {
    return [QueryKeysEnum.registryData, registryId, "individual", individualId]
  }
  static registrySchemaDetail(registryId: string = ""): string[] {
    return [QueryKeysEnum.registrySchema, registryId]
  }
  static variantmap(): string[] {
    return [QueryKeysEnum.variantmap]
  }
  static publicStatChart(registryAbbr: string = "", chartName: string = ""): string[] {
    return [QueryKeysEnum.stats, registryAbbr, chartName]
  }
  static organizations(): string[] {
    return [QueryKeysEnum.organizations]
  }
  static organizationDetail(organizationId: string = ""): string[] {
    return [QueryKeysEnum.organizations, organizationId]
  }
  static schemas(): string[] {
    return [QueryKeysEnum.schemas]
  }
  static schemaVersions(): string[] {
    return [QueryKeysEnum.schemaVersions]
  }
  static schemaVersionsDetail(schemaId: string = ""): string[] {
    return [QueryKeysEnum.schemaVersions, schemaId]
  }
}
